export const urlSisa = () => {
    //const urlSisa = 'cl-sisabackoffice-dev.smdigital.cl';
    //const urlSisa = 'localhost:8080';
    const urlSisa = 'backoffice.santaisabel.cl';
    return urlSisa;
}

export const urlBase = () => {
    const url = window.location.host;
    return url;
}

